export const guestPaymentConstants = {
    ADOBE_ANALYTICS_FORM_NAME: 'Guest Payment',
    GUEST_PAYMENT_STEPS: [
        "Payment details",
        "Verification",
        "Confirmation"
    ]
}